import { unescape } from 'lodash';

export const getFileUrl = (fileUrl: string) => {
  return fileUrl?.includes('https://mymathscloud.ams3.digitaloceanspaces.com/')
    ? unescape(fileUrl.replace('https://mymathscloud.ams3.digitaloceanspaces.com/', ''))
    : fileUrl;
};

export const getDownloadUrl = (fileUrl: string, id: string) => {
  return `${process.env.GATSBY_BACKEND_URL}/api/download/modules/${fileUrl}?id=${id}`;
};
